import React, { Component } from 'react';
import { Spin, Col, Button, Icon, Modal, Form, Row, Select, InputNumber } from 'antd';
import { openNotification } from '../../util/notificaciones';
import CatalogoRequest from '../../services/Catalogo';
import moment from 'moment'
import 'moment/locale/es';
import ArticulosPTRequest from '../../services/ArticulosPT';
import { ShowMenuItem } from '../../util/ShowMenuItem';
import { roles } from '../../util/Roles';
moment.locale('es')
const { Option } = Select;
const { confirm } = Modal;
const exceptThisSymbols = ["e", "E", "+", "-"];

/**
 * Clase para ver el proceso de mostrar form de productos
 */
class FormArticulosPT extends Component {
    state = {
        cargando: false,
        bloquearBotones: false,
        cancelModalConfirm: false,
        externo: this.props.externo
    }

    /**
     * Comportamiento del modal cada vez que se despliega.
     * Se aplica al editar o visualizar datos
     * @param: prevProps. propiedades que tenia el componente antes de ser
     * desplegado
     * @return: nada.
     */
    componentDidUpdate = (prevProps) => {
    }

    /**
     * Función que se manda a llamar cuando se cierra el modal
     * de generar un pedido.
     */
    handleCancel = () => {
        this.props.esconderModal(false);
        this.props.form.resetFields();
        this.setState({
            cargando: false
        })
    }

    /**
     * Función que se manda a llamar cuando cambia la variación
     */
    handleChangeVariacion = (ev) => {
        // ev.preventDefault();
    }

    /**
     * Función que se ejecuta cuando se confirma edición de estatus
     * @param: e. valor para prevent
     * @return: nada.
     */
    showConfirm = (e) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                confirm({
                    title: 'Confirmar',
                    content: this.props.arrArticulos?.length === 1 ? <div><b>¿Está seguro de editar el artículo?</b> Se cambiará la información del artículo seleccionado.</div> : <div><b>¿Está seguro de editar el artículo?</b> Se cambiará la información de los artículos seleccionados.</div>,
                    okText: 'Aceptar',
                    cancelText: 'Cancelar',
                    okButtonProps: {
                        id: 'boton-aceptar-confirmacion-estatus-form',
                    },
                    cancelButtonProps: {
                        id: 'boton-cancelar-confirmacion-estatus-form',
                    },
                    onOk: () => {
                        this.setState({ cargando: true, bloquearBotones: true }, this.editarProductos)
                    },
                });
            }
        });
    }

    /**
     * Función que se cambia el estatus de los productos
     * @param: nada.
     * @return: nada.
     */
    editarProductos = () => {
        this.props.form.validateFields((err, values) => {
            if (!err) {
                if(ShowMenuItem([roles.Admin])){
                    if(values.variacion < 0)
                        values.variacion = 0
                }
                /*if(values.variacion === undefined || values.variacion < 0){
                    this.setState({ bloquearBotones: false, cargando: false })
                    openNotification(
                        "No se permite modificar este artículo sin capturar la variación, es necesario que lo modifique un usuario administrador.",
                        "Aviso",
                    )
                }
                else{*/
                let state = { ...this.state }
                let objEnviar = {};
                objEnviar.activo = values.estatus === 1 ? true : false;
                objEnviar.variacion = values.variacion;
                objEnviar.drivesSelected = this.props.drivesSelected;
                objEnviar.externo = this.props.externo;
                objEnviar.articulos = this.props.modo === 'uno' ? [this.props.producto_selected.idArticuloInventario] : this.props.arrArticulos.map(item => item.idArticuloInventario);

                state.bloquearBotones = true;
                state.cargando = true;
                this.setState(state, () => {
                    ArticulosPTRequest.EditarArticulosPT(objEnviar)
                        .then(response => {
                            state.cargando = false;
                            state.bloquearBotones = false
                            
                            this.props.form.resetFields();
                            this.setState(state, this.props.esconderModal(true, response.data))
                            openNotification(
                                response?.data?.cuerpo,
                                response?.data?.titulo,
                            )
                        })
                        .catch(err => {
                            this.setState({ bloquearBotones: false, cargando: false })
                            openNotification(
                                err?.response?.data?.cuerpo,
                                "Error",
                            )
                        })
                })
                //}
            }
        });
    }
    
    visibleVariacion = (value) => {
        if(value){
            return "block"
        }
        return "none"
    }

    render() {
        const { getFieldDecorator } = this.props.form;
        let titulo = "Editar información " + (this.props.modo === 'uno' ? "del artículo" : "de los artículos"); 
        return (
            <div>
                <Modal
                    title={titulo}
                    onCancel={this.handleCancel}
                    visible={this.props.visible}
                    onOk={this.showConfirm}
                    width={"75%"}
                    maskClosable={false}
                    centered={true}
                    className='modal-editar-articulo'
                    footer={
                        [
                            <Button
                                id="boton-regresar-form-estatus-productos"
                                className="btnCancelar"
                                key="back"
                                disabled={this.state.bloquearBotones}
                                onClick={this.handleCancel}> Regresar
                            </Button>,
                            <Button
                                id="boton-guardar-form-estatus-productos"
                                className={'btnVerCrearGuardar'}
                                key="submit"
                                disabled={this.state.bloquearBotones}
                                onClick={this.showConfirm}
                                type="primary"> Guardar
                            </Button>,
                        ]
                    }
                >
                    <Spin
                        tip="Cargando..."
                        indicator={<Icon type="loading" style={{ fontSize: 24, color: "#e0cbae" }} spin />}
                        spinning={this.state.cargando}
                        style={{ color: "#e0cbae", backgroundColor: "rgb(255,255,255,0.8)" }}>
                        <Form onSubmit={this.showConfirm}>
                            <Row gutter={12}>
                                <Col span={24}>
                                    <Form.Item label={"Estatus"} colon >
                                        {getFieldDecorator('estatus', {
                                            rules: [
                                                { required: true, message: 'Por favor, seleccione un estatus.' },
                                            ],
                                            initialValue: (this.props.modo === "varios" || this.props.drivesSelected.length > 1 ? null :
                                                this.props.producto_selected?.valores.Activo === true ? 1 : 0)
                                        })(
                                            
                                            <Select
                                                id="select-estatus-form-productos"
                                                showSearch
                                                style={{ width: "100%" }}
                                                defaultActiveFirstOption={false}
                                                notFoundContent='No hay opciones'
                                                placeholder="Seleccionar..."
                                                optionFilterProp="children"
                                                // onChange={this.handleChangeEstatus}
                                                //disabled={this.props.producto_selected?.valores.Editable === 0 || this.props.disabledStatus}
                                                allowClear >
                                                <Option value={null} disabled={true}>Seleccionar...</Option>
                                                <Option value={1} key={1} disabled={true}>Activo</Option>
                                                <Option value={0} key={2} disabled={this.props.producto_selected?.valores.Editable === 0 || this.props.disabledStatus}>Inactivo</Option>
                                            </Select>
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col span={24}>
                                    {/*<Form.Item label={"Variación"} colon style={{display: this.visibleVariacion(ShowMenuItem([roles.Admin]))}}>
                                        {getFieldDecorator('variacion', {
                                            rules: [ ],
                                            initialValue: (this.props.modo ==='varios' ? 0
                                                        : this.props.producto_selected?.valores.Variacion )
                                        })(
                                            <InputNumber 
                                                onChange={this.handleChangeVariacion}
                                                onKeyDown={e => exceptThisSymbols.includes(e.key) && e.preventDefault()}
                                                formatter={value => String(value).replace(/[,-]$/, '')}
                                                parser={value => String(value).replace(/[,-]$/, '')}
                                                min={0}
                                                max={9999}
                                                maxLength={7}
                                                precision={2}/>
                                        )}
                                    </Form.Item>*/}
                                </Col>
                            </Row>
                        </Form>
                    </Spin>
                </Modal>
            </div >
        )
    }
}

export default Form.create()(FormArticulosPT);